import { render } from "./GroupTreeCheckbox.vue?vue&type=template&id=38a13f9d&scoped=true"
import script from "./GroupTreeCheckbox.vue?vue&type=script&lang=js"
export * from "./GroupTreeCheckbox.vue?vue&type=script&lang=js"

import "./GroupTreeCheckbox.vue?vue&type=style&index=0&id=38a13f9d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a13f9d"]])

export default __exports__